"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//import InteractionNodesUI from './interaction';
var camera_1 = __importDefault(require("./camera"));
var utils_1 = require("../utils/utils");
var tsm_1 = require("@tlaukkan/tsm");
function initWorkIndicator(comp, zlbolt) {
    if (zlbolt === undefined) {
        console.log("Trying to initialise work indicator without zlbolt?");
    }
    else {
        zlbolt.addEventListener('streamReady', function (err, data) {
            comp.setState(function (state) {
                return {
                    zlready: true
                };
            });
        });
        zlbolt.addEventListener('streamConnect', function (err, data) {
            comp.setState(function (state) {
                return {
                    zlready: false
                };
            });
        });
        zlbolt.addEventListener('2DProgressBarChanged', function (err, data) {
            if (!err) {
                if (data.type === "value") {
                    var prog_1 = __assign({}, comp.state);
                    prog_1.d2dActivity.segments[data.id] = data.value;
                    var progress_1 = Object.values(prog_1.d2dActivity.segments).reduce(function (a, c) { return a + c; });
                    comp.setState(function () {
                        return __assign(__assign({}, prog_1), { d2dActivity: __assign(__assign({}, prog_1["d2dActivity"]), { progress: progress_1 }) });
                    });
                }
                else if (data.type === "setup") {
                    comp.setState(function () {
                        return __assign(__assign({}, comp.state), { d2dActivity: {
                                segments: {},
                                progress: 0,
                                total: data.totalMax
                            } });
                    });
                }
            }
        });
    }
}
exports.initWorkIndicator = initWorkIndicator;
function initRichDataIndicator(comp, zlbolt, datasource) {
    if (zlbolt === undefined) {
        console.log("Trying to initialise rich indicator without zlbolt?");
    }
    else {
        /*  zlbolt.addEventListener('modeChange', function(mode:string, status:any) {
              console.log("modeChange", mode, status);
              if (mode === "2D" && status === "pending"){
                  new Promise((resolve, reject) => {
                      zlbolt.getStreamController().getCameraPosRotFov((err:any, res:any) => {
                          if (err) {
                              reject(err);
                          } else {
                              resolve(res);
                          }
                      });
                  }).then((cp:any) => {
                      let cpos = new vec3([cp.posx, cp.posy, cp.posz]);
                      let got = getCameraForPos(cpos, cpos);  // curent position and target position are the same thing in this case
                      if (got){
                          if (got.dist < 35 && window.zlurlparams.autocam === "smooth"){
                              zlbolt.setPosRotFov(got.cam, {smooth:true});
                          }
                      }
                  });
              }
          });*/
        zlbolt.addEventListener('streamReady', function (err, data) {
            /*
  
              zlbolt.getInteractionNodesAPI((err: any, api: any) => {
                  InteractionNodesUI.create(zlbolt, undefined, api);
              });
  */
            zlbolt.getRichDataStreamAPI(function (error, api) {
                if (error) {
                    console.error(error);
                }
                if (api) {
                    var connectionTime_1 = new Date().getTime();
                    api.subscribeAll(datasource, function (data, id, fieldName) {
                        var timeIn = new Date().getTime() - connectionTime_1;
                        if (data) {
                            var focusId = "";
                            var ids_1 = [];
                            var ignore = comp.state["ignoreList"];
                            if (data.points) {
                                ids_1 = Object.keys(data.points);
                                focusId = ids_1.join("_");
                                if (focusId !== comp.state["id"] && focusId.length > 0 && window.zlurlparams.autocam && ids_1.length > 0) {
                                    if (timeIn > 500) {
                                        var usableIndex_1 = 0;
                                        while ((usableIndex_1 < ids_1.length && comp.state["ignoreList"].indexOf(ids_1[usableIndex_1]) >= 0) || (data.points[ids_1[usableIndex_1]] && data.points[ids_1[usableIndex_1]].bounds3DSize && Object.values(data.points[ids_1[usableIndex_1]].bounds3DSize).every(function (curr) { return curr === 0; }))) {
                                            console.log("Skipping bad data");
                                            usableIndex_1++;
                                        }
                                        if (usableIndex_1 < ids_1.length) {
                                            new Promise(function (resolve, reject) {
                                                zlbolt.getStreamController().getCameraPosRotFov(function (err, res) {
                                                    if (err) {
                                                        reject(err);
                                                    }
                                                    else {
                                                        resolve(res);
                                                    }
                                                });
                                            }).then(function (cp) {
                                                console.log("current camera pos", data);
                                                var info = data.points[ids_1[usableIndex_1]];
                                                if (info) {
                                                    var p = info.bounds3DMax;
                                                    if ((cp.posx < 0 && info.bounds3DMin.x < 0) || p.x < 0) {
                                                        // flip which side we're looking for based on bounds
                                                        //console.log("flipped sides "+p.x);
                                                        p = info.bounds3DMin;
                                                        //console.log("using min bounds", p);
                                                    }
                                                    else {
                                                        //console.log("using max bounds", p);
                                                    }
                                                    //console.log("dp", data.points, ids, p);
                                                    if (info.bounds3DSize && info.bounds3DSize.z < 2.5) {
                                                        // Get bias axis, first check if all values are equal
                                                        var bias = Object.values(info.bounds3DSize).every(function (item) { return item === info.bounds3DSize.x; }) ? "" : "x";
                                                        if (bias !== "") {
                                                            bias = Object.keys(info.bounds3DSize).reduce(function (cur, nxt) { return info.bounds3DSize[cur] > info.bounds3DSize[nxt] ? cur : nxt; }).replace(/\s/g, '');
                                                        }
                                                        //console.log("bounds3D::BIAS:: ", bias);
                                                        var got = camera_1.default(new tsm_1.vec3([p.x, p.y, p.z]), new tsm_1.vec3([cp.posx, cp.posy, cp.posz]), bias);
                                                        console.log("Get camera for pos", got);
                                                        if (got) {
                                                            // temp check until this is widely used
                                                            if (got.dist < 35 && window.zlurlparams.autocam === "smooth") {
                                                                zlbolt.setPosRotFov(got.cam, { smooth: utils_1.svMatchOrNewer(window.zlbolt.version, "3.208.0") ? 0.5 : true });
                                                            }
                                                            else {
                                                                zlbolt.setPosRotFov(got.cam);
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        // long item, don't bother moving
                                                        //console.log("not moving camera for such a big item")
                                                    }
                                                }
                                            });
                                        }
                                        else {
                                            console.log("none of the data was usable");
                                        }
                                    }
                                    else {
                                        console.log("some rich data was suspiciously early, will be ignored", ids_1);
                                        ignore = ids_1;
                                    }
                                }
                                comp.setState(__assign(__assign({}, comp.state), { showMe: false, points: data.points, id: focusId, ignoreList: ignore }));
                            }
                        }
                    });
                }
            });
            comp.setState(function (state) {
                return __assign(__assign({}, state), { zlready: true });
            });
        });
        var hideMe = function () {
            zlbolt.getRichDataStreamAPI(function (error, api) {
                if (error) {
                    console.error(error);
                }
                if (api) {
                    api.unsubscribeAll(datasource, function () { });
                }
            });
            comp.setState(__assign(__assign({}, comp.state), { showMe: false, points: {} }));
        };
        zlbolt.addEventListener('onStreamDisconnect', hideMe);
    }
}
exports.initRichDataIndicator = initRichDataIndicator;
//# sourceMappingURL=indicators.js.map